import React from "react";

export default class NormalVideoPlayer extends React.Component {
  componentDidMount() {
    this.videoNode.src = this.props.sources[0].src;
    this.videoNode.load();
    this.videoNode.play();
  }

  componentDidUpdate() {
    const time = this.videoNode.currentTime;
    this.videoNode.src = this.props.sources[this.props.selectedSource].src;
    this.videoNode.load();
    this.videoNode.currentTime = time;
    this.videoNode.play();
  }

  // destroy player on unmount
  //   componentWillUnmount() {
  //     if (this.player) {
  //       this.player.dispose();
  //     }
  //   }

  // wrap the player in a div with a `data-vjs-player` attribute
  // so videojs won't create additional wrapper in the DOM
  // see https://github.com/videojs/video.js/pull/3856
  render() {
    return (
      <>
        <div
          style={{
            width: this.props.width ? this.props.width : "100%",
            height: this.props.height ? this.props.height : "100%",
            border : "1px solid gray"
          }}
        >
          <video
            ref={(node) => (this.videoNode = node)}
            width="100%"
            height="100%"
            controls
          ></video>
        </div>
      </>
    );
  }
}
